import myFirebase from '../config/config';
import apiCaller from './apiCallerOutstanding';

async function getUtils(type) {
  const endPoint = `utils/${type}`;
  const currentUserDetails = myFirebase.auth().currentUser;
  const { Aa: token } = currentUserDetails;
  if (!currentUserDetails) return [];
  try {
    const result = [];
    const response = await apiCaller(
      endPoint,
      {},
      `Bearer ${token}`,
      'nh-base',
      'get'
    );
    const data = response?.data?.Data;
    if (type === 'truck_type' || type === 'cities') {
      data.forEach(item => {
        result.push({
          label: item,
          value: item,
        });
      });
    }
    return result;
  } catch (e) {
    return [];
  }
}

export default getUtils;
